/**
 * @desc MQ推送日志
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: defs.aider.SendParamDto, options?: any) {
  return updateResponse(
    http(URL + `/log/message/send`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
